export default "__VITE_ASSET__B$e$XgP1__"